module.exports = __webpack_public_path__ + "static/media/logo_default_white.d1d23ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/logo_default_white.png
// module id = ./src/statics/images/logo_default_white.png
// module chunks = 0